import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initializeAnalytics();
    document.addEventListener("turbo:load", this.initializeAnalytics);
  }

  initializeAnalytics() {
    window.dataLayer = window.dataLayer || [];
    function gtag(){ dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', 'G-CW2K1QK0CL');
  }
}
